export default "__VITE_ASSET__z6ICE5bL__"